import './PortContactPage.css'
import 'antd/dist/reset.css'
import React from 'react'
import { Space, Image, ConfigProvider } from 'antd'
import { PhoneOutlined, MailOutlined, WechatOutlined } from '@ant-design/icons'
import zhCN from 'antd/es/locale/zh_CN' // 引入中文语言包
import SalesQrCode from '../../images/company/sales_qrcode.jpg'
import SupportQrCode from '../../images/company/support_qrcode.jpg'
import PortBottomLayout from '../common/PortBottomLayout'

export default class PortContactPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <div>
        <div className="PortContactPage">
          <div className="PortContactPageTitle">{'商务负责人'}</div>
          <div className="PortContactPageWrapper">
            <Space style={{ marginTop: 30 }}>
              <PhoneOutlined style={{ fontSize: 16 }} />
              <div className="PortContactPageMethod">电话</div>
            </Space>
            <div className="PortContactPageContent">17625997856</div>
            <Space style={{ marginTop: 30 }}>
              <MailOutlined style={{ fontSize: 16 }} />
              <div className="PortContactPageMethod">邮箱</div>
            </Space>
            <div className="PortContactPageContent">
              sales@keystridevalve.com
            </div>
            <Space style={{ marginTop: 30 }}>
              <WechatOutlined style={{ fontSize: 16 }} />
              <div className="PortContactPageMethod">
                微信（请扫下方二维码，可点击放大）
              </div>
            </Space>
            <ConfigProvider locale={zhCN}>
              <Image
                src={SalesQrCode}
                width={200}
                preview={{ src: SalesQrCode, mask: null }}
                style={{ cursor: 'pointer', marginTop: 15, marginBottom: 15 }}
              />
            </ConfigProvider>
          </div>

          <div className="PortContactPageTitle">{'技术负责人'}</div>
          <div className="PortContactPageWrapper">
            <Space style={{ marginTop: 30 }}>
              <PhoneOutlined style={{ fontSize: 16 }} />
              <div className="PortContactPageMethod">电话</div>
            </Space>
            <div className="PortContactPageContent">13905285116</div>
            <Space style={{ marginTop: 30 }}>
              <MailOutlined style={{ fontSize: 16 }} />
              <div className="PortContactPageMethod">邮箱</div>
            </Space>
            <div className="PortContactPageContent">
              supportmaster@keystridevalve.com
            </div>
            <Space style={{ marginTop: 30 }}>
              <WechatOutlined style={{ fontSize: 16 }} />
              <div className="PortContactPageMethod">
                微信（请扫下方二维码，可点击放大）
              </div>
            </Space>
            <ConfigProvider locale={zhCN}>
              <Image
                src={SupportQrCode}
                width={200}
                preview={{ src: SupportQrCode, mask: null }}
                style={{ cursor: 'pointer', marginTop: 15, marginBottom: 15 }}
              />
            </ConfigProvider>
          </div>

          <div style={{ height: 30 }} />
        </div>

        <PortBottomLayout {...this.props} />
      </div>
    )
  }
}
